/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from '@vlinder-web/plugin-agent-service-react';
import {
  IStaticPageContentMethods,
  StaticPageContentService,
  IPaymentUserMethods,
  PaymentUserService,
  URLService,
  IURLMethods,
  CreateSessionService,
  ICreateSessionMethods,
  ICheckStatusMethods,
  CheckStatusService,
  GetFeeService,
  IGetFeeMethods,
} from './plugins';

export type TAgent = IStaticPageContentMethods &
  IPaymentUserMethods &
  IURLMethods &
  ICreateSessionMethods &
  ICheckStatusMethods &
  IGetFeeMethods;

const getPlugins = () => {
  return [
    new StaticPageContentService(),
    new PaymentUserService(),
    new URLService(),
    new CreateSessionService(),
    new CheckStatusService(),
    new GetFeeService(),
  ];
};

export const getAgent = () => {
  return createAgent<TAgent>({
    plugins: getPlugins(),
  });
};
